<template>
    <div class="landing-page">
        <comHeader />
        <!-- <el-header>
            <div class="header">
                <div v-if="ismobile" style="width:45px;"><van-icon size="28" name="bars" color="#666666"
                        @click="showlefttab" /></div>
                <div class="logo-box" @click="toclick('/apk')">
                    <img src="../assets/logo.png" alt="" style="cursor: pointer">
                    <h1 style="cursor: pointer">dic.cool</h1>
                </div>
                <div v-if="!ismobile" class="tab-box">
                    <p class="tab-item" @click="toclick('/apk')">安装教程</p>
                    <p class="tab-item" @click="toclick('/about')">使用教程</p>
                    <p class="tab-item" @click="toclick('/feedback')">问题反馈</p>
                    <p class="free_btn" @click="handleInstall(browserId)">免费使用</p>
                </div>
            </div>
        </el-header> -->
        <div style="max-height:calc(100vh - 70px);overflow-y: auto;width: 100%;">
            <!-- Hero Section -->
            <section class="hero-section">
                <div class="hero-bg-overlay"></div>
                <div class="hero-container">
                    <div class="hero-content">
                        <div class="hero-title">
                            <h1>
                                <span class="title-normal">打破语言高墙 </span>
                                <span class="title-gradient">重塑科研效率</span>
                            </h1>
                            <p class="hero-subtitle">
                                从打破语言障碍，到激发研究灵感。酷学术深度整合智能翻译、文献推荐、 Al问答、引文整理，为您打造流畅、高效的沉浸式科研工作流。
                            </p>
                        </div>

                        <div class="stats-container">
                            <div class="stat-item">
                                <div class="stat-value">
                                    <span>20000</span>
                                    <span class="plus">+</span>
                                </div>
                                <p class="stat-label">科研人员选择</p>
                            </div>
                            <div class="stat-item">
                                <div class="stat-value">
                                    <span>200万</span>
                                    <span class="plus">+</span>
                                </div>
                                <p class="stat-label">累计使用量</p>
                            </div>
                            <div class="stat-item">
                                <div class="stat-value">95%</div>
                                <p class="stat-label">用户推荐度</p>
                            </div>
                        </div>

                        <div class="cta-button-container">
                            <button class="cta-button" @click="handleInstall(5)">
                                <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
                                    <path d="M10 2.5V12.5M10 12.5L15 7.5M10 12.5L5 7.5" stroke="white"
                                        stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                    <path
                                        d="M2.5 15V16.25C2.5 16.8023 2.94772 17.25 3.5 17.25H16.5C17.0523 17.25 17.5 16.8023 17.5 16.25V15"
                                        stroke="white" stroke-width="1.5" stroke-linecap="round" />
                                </svg>
                                免费安装插件
                            </button>
                            <!-- browserId -->
                            <div v-if="browserId == 1">如果您的电脑可以正常访问谷歌，可前往应用商店<a :href="urlList[+browserId]"
                                    target="_blank">
                                    一键安装</a></div>
                        </div>

                        <div class="features-tags">
                            <div class="feature-tag">
                                <div class="tag-icon">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12"
                                        fill="none">
                                        <path fill-rule="evenodd" clip-rule="evenodd"
                                            d="M1 6L2.25 4.75L4.75 7.25L9.75 2.25L11 3.5L4.75 9.75L1 6Z" fill="#5FEF00"
                                            stroke="#5FEF00" stroke-width="0.833333" stroke-linecap="round"
                                            stroke-linejoin="round" />
                                    </svg>
                                </div>
                                <span>完全免费</span>
                            </div>
                            <div class="feature-tag">
                                <div class="tag-icon">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12"
                                        fill="none">
                                        <path fill-rule="evenodd" clip-rule="evenodd"
                                            d="M1 6L2.25 4.75L4.75 7.25L9.75 2.25L11 3.5L4.75 9.75L1 6Z" fill="#5FEF00"
                                            stroke="#5FEF00" stroke-width="0.833333" stroke-linecap="round"
                                            stroke-linejoin="round" />
                                    </svg>
                                </div>
                                <span>支持主流浏览器</span>
                            </div>
                            <div class="feature-tag">
                                <div class="tag-icon">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12"
                                        fill="none">
                                        <path fill-rule="evenodd" clip-rule="evenodd"
                                            d="M1 6L2.25 4.75L4.75 7.25L9.75 2.25L11 3.5L4.75 9.75L1 6Z" fill="#5FEF00"
                                            stroke="#5FEF00" stroke-width="0.833333" stroke-linecap="round"
                                            stroke-linejoin="round" />
                                    </svg>
                                </div>
                                <span>一键安装即用</span>
                            </div>
                        </div>

                        <div class="browsers-list">
                            <div class="browser-item" @click="handleInstall(5)">
                                <div class="browser-icon">
                                    <img src="../assets/home/chrome.svg" alt="Chrome" />
                                </div>
                                <p>谷歌浏览器</p>
                            </div>
                            <div class="divider"></div>
                            <div class="browser-item" @click="handleInstall(2)">
                                <div class="browser-icon">
                                    <img src="../assets/home/edge.svg" alt="Edge" />
                                </div>
                                <p>Edge 浏览器</p>
                            </div>
                            <div class="divider"></div>
                            <div class="browser-item" @click="handleInstall(3)">
                                <div class="browser-icon">
                                    <img src="../assets/home/firefox.svg" alt="Firefox" />
                                </div>
                                <p>火狐浏览器</p>
                            </div>
                            <div class="divider"></div>
                            <div class="browser-item" @click="handleInstall(4)">
                                <div class="browser-icon">
                                    <img src="../assets/home/360.svg" alt="360" />
                                </div>
                                <p>360浏览器</p>
                            </div>
                            <div class="divider"></div>
                            <div class="browser-item" @click="handleInstall(5)">
                                <div class="browser-icon">
                                    <img src="../assets/home/zip.svg" alt="ZIP" />
                                </div>
                                <p>ZIP 安装包</p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <!-- Problems Section -->
            <section class="problems-section">
                <div class="section-container">
                    <div class="section-header">
                        <!--  -->
                        <h2>科研路上的
                            <span class="title_back_text"><span style="z-index: 1;position: relative;">"拦路虎"</span><img
                                    src="../assets/home/title_back.svg" class="title_back" /> </span>，你遇到过几个
                        </h2>
                        <p>90%的时间不该浪费在语言障碍和机械劳动上</p>
                    </div>

                    <div class="problems-grid">
                        <div class="problem-card problem-1">
                            <div class="problem-content">
                                <h3>英文文献读太慢，理解不透？</h3>
                                <div class="problem-points">
                                    <div class="point-item">
                                        <img src="../assets/home/image4.png" alt="">
                                        <span>专业术语翻译不准</span>
                                    </div>
                                    <div class="point-item">
                                        <img src="../assets/home/image4.png" alt="">
                                        <span>长难句逻辑理不清</span>
                                    </div>
                                </div>
                                <p class="problem-desc">
                                    面对超长英文PDF，查词打断思路，机翻语序不通，外网代理导致翻译速度超慢。读完一篇花一下午，关键逻辑还是似懂非懂。
                                </p>
                            </div>
                            <div class="problem-icon emoji-icon">
                                <img src="../assets/home/image1.png" alt="problem1" />
                            </div>
                        </div>

                        <div class="problem-card problem-2">
                            <div class="problem-content">
                                <h3>多库检索来回跳转，错过关键灵感？</h3>
                                <div class="problem-points">
                                    <div class="point-item">
                                        <img src="../assets/home/image4.png" alt="">
                                        <span>关键词匹配效率低</span>
                                    </div>
                                    <div class="point-item">
                                        <img src="../assets/home/image4.png" alt="">
                                        <span>错过跨领域启发性论文</span>
                                    </div>
                                </div>
                                <p class="problem-desc">
                                    读完一篇论文，想找相关的上下游研究，都需要在多个数据库间反复跳转检索。缺乏上下文关联推荐，容易遗漏关键的前沿进展。
                                </p>
                            </div>
                            <div class="problem-icon emoji-icon">
                                <img src="../assets/home/image2.png" alt="problem2" />
                            </div>
                        </div>

                        <div class="problem-card problem-3">
                            <div class="problem-content">
                                <h3>文献管理一团乱麻，整理费时？</h3>
                                <div class="problem-points">
                                    <div class="point-item">
                                        <img src="../assets/home/image4.png" alt="">
                                        <span>文献阅读费事</span>
                                    </div>
                                    <div class="point-item">
                                        <img src="../assets/home/image4.png" alt="">
                                        <span>引文格式反复修改</span>
                                    </div>
                                </div>
                                <p class="problem-desc">
                                    文献资料超长，需要长时间阅读消化；文献写作，调整参考文献格式，耗费了大量本该用来思考的时间。
                                </p>
                            </div>
                            <div class="problem-icon emoji-icon">
                                <img src="../assets/home/image3.png" alt="problem3" />
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <!-- Comparison Section -->
            <section class="comparison-section">
                <div class="section-container">
                    <h2 class="section-title">对比一目了然，功能更全面</h2>

                    <div class="comparison-wrapper">
                        <img src="../assets/home/image5.png" alt="">
                    </div>
                </div>
            </section>

            <!-- Translation Features Section -->
            <section class="features-section">
                <div class="section-container">
                    <div class="section-header">
                        <h2>打破语言壁垒，还原母语级阅读体验</h2>
                        <p>网页&PDF一键双语对照，读懂论文快十倍</p>
                    </div>

                    <div class="features-showcase">
                        <!-- Feature 1: Speed Test -->
                        <div class="feature-row">
                            <div class="feature-visual">
                                <img src="../assets/home/image6.png" alt="">
                            </div>
                            <div class="feature-description">
                                <h3>全球节点智能测速<br />告别在线加载"转圈圈"</h3>
                                <p>无论是拥挤延迟的公网速度，还是不稳定的外网代理。我们自动为你寻找最快的翻译线路。不仅准，更要快，因为你的灵感等不起。</p>
                                <div class="feature-highlights">
                                    <div class="highlight-item">
                                        <!-- 紫色 -->
                                        <img src="../assets/home/purpleLeft.png" class="img-left">
                                        <h4 class="purple-text">毫秒级响应</h4>
                                        <p>无需漫长等待，点击翻译，酷学术都能为你快速翻译。</p>
                                    </div>
                                    <div class="highlight-item align-right">
                                        <img src="../assets/home/purpleRight.png" class="img-right">
                                        <h4 class="purple-text">稳定不掉线</h4>
                                        <p>即使网络波动也能保持翻译连续进行，保持阅读连贯性。</p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <!-- Feature 2: Web Translation -->
                        <div class="feature-row reverse">
                            <div class="feature-description">
                                <h3>网页沉浸式对照翻译<br />像读母语一样读Nature/Science</h3>
                                <p>浏览外文期刊官网时，酷学术直接在原网页行间嵌入双语对照。保留原文语境的同时，让你秒懂核心语义，享受行云流水的阅读快感。</p>
                                <div class="feature-highlights">
                                    <div class="highlight-item">
                                        <img src="../assets/home/blueLeft.png" class="img-left">
                                        <h4 class="blue-text"><span class="blue-text">原网页呈现</span></h4>
                                        <p>支持原位段落对照翻译，网页展示双语内容，进行沉浸式阅读。</p>
                                    </div>
                                    <div class="highlight-item align-right">
                                        <img src="../assets/home/blueRight.png" class="img-right">
                                        <h4><span class="blue-text">格式无损&nbsp;</span></h4>
                                        <p>只翻译文字，完美保留原网页的图片、公式和代码块。</p>
                                    </div>
                                </div>
                            </div>
                            <div class="feature-visual">
                                <img src="../assets/home/image7.png" alt="">
                            </div>
                        </div>

                        <!-- Feature 3: Word Selection -->
                        <div class="feature-row">
                            <div class="feature-visual">
                                <img src="../assets/home/image8.png" alt="" />
                            </div>
                            <div class="feature-description">
                                <h3>哪里不懂划哪里<br />专业术语"秒"看懂</h3>
                                <p>不需要通篇翻译？只想查一个术语？鼠标划词选择，即可立即查看翻译结果，让你的注意力始终聚焦在内容本身，保持连贯的深度思考流。</p>
                                <div class="feature-highlights">
                                    <div class="highlight-item">
                                        <img src="../assets/home/purpleLeft.png" class="img-left">
                                        <h4 class="purple-text">行业特色引擎</h4>
                                        <p>选中文字，即刻调用DeepL 或译采大模型，专治各种"学术黑话"。</p>
                                    </div>
                                    <div class="highlight-item align-right">
                                        <img src="../assets/home/purpleRight.png" class="img-right">
                                        <h4 class="purple-text">极简交互</h4>
                                        <p>鼠标划选快速触发，不打扰正常阅读流。</p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <!-- Feature 4: PDF Translation -->
                        <div class="feature-row reverse">
                            <div class="feature-description">
                                <h3>同版式还原PDF翻译<br />文献阅读零障碍</h3>
                                <p>上传 PDF 文档，酷学术帮您翻译成一份排版一致的文档。 告别格式错乱，省去二次校对与排版的繁琐成本。</p>
                                <div class="feature-tags-row">
                                    <div class="feature-tag-item">
                                        <span style="width: 118px;">保留图表</span>
                                    </div>
                                    <div class="feature-tag-item">
                                        <span>保留公式</span>
                                    </div>
                                    <div class="feature-tag-item">
                                        <span>支持导出</span>
                                    </div>
                                </div>
                            </div>
                            <div class="feature-visual">
                                <img src="../assets/home/image9.png" alt="">
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <!-- AI Features Section -->
            <section class="ai-section">
                <div class="section-bg-decoration"></div>
                <div class="section-container">
                    <div class="section-header">
                        <h2>从"读懂"到"产出"：AI 全程帮你提炼与输出</h2>
                        <p>用推荐发现前沿灵感，用问答吃透核心逻辑，用引文辅助完美写作。</p>
                    </div>

                    <div class="ai-features-grid">
                        <div class="ai-features-left">
                            <div class="ai-card" :class="{ 'active': aiCardIndex == 1 }" @click="aiCardIndex = 1">
                                <h4>边读边找：智能文献推荐</h4>
                                <div class="ai-points">
                                    <div class="ai-point">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12"
                                            viewBox="0 0 12 12" fill="none">
                                            <path d="M10.75 2.75L4.21875 9.25L1.25 6.29545" stroke="#FF8D1F"
                                                stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                        </svg>
                                        <span>基于上下文语义推荐</span>
                                    </div>
                                    <div class="ai-point">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12"
                                            viewBox="0 0 12 12" fill="none">
                                            <path d="M10.75 2.75L4.21875 9.25L1.25 6.29545" stroke="#FF8D1F"
                                                stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                        </svg>
                                        <span>实时展示引用量与年份</span>
                                    </div>
                                </div>
                            </div>

                            <div class="ai-card" :class="{ 'active': aiCardIndex == 2 }" @click="aiCardIndex = 2">
                                <h4>AI 智能问答&快速总结</h4>
                                <div class="ai-points">
                                    <div class="ai-point hash">
                                        <span class="hash-symbol">#</span>
                                        <span>快速解释页面内容</span>
                                    </div>
                                    <div class="ai-point hash">
                                        <span class="hash-symbol">#</span>
                                        <span>总结本文创新点</span>
                                    </div>
                                </div>
                            </div>

                            <div class="ai-card" :class="{ 'active': aiCardIndex == 3 }" @click="aiCardIndex = 3">
                                <h4>引文生成与导出</h4>
                                <div class="ai-points">
                                    <div class="ai-point">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12"
                                            viewBox="0 0 12 12" fill="none">
                                            <path d="M10.75 2.75L4.21875 9.25L1.25 6.29545" stroke="#FF8D1F"
                                                stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                        </svg>
                                        <span>支持所有主流学术格式</span>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="ai-features-right">
                            <div class="ai-demo-card">
                                <div class="demo-title-bar">
                                    <h4>{{aiCardIndex == 1 ? '告别信息茧房' : aiCardIndex == 2 ? 'AI 智能问答&快速总结' : '引文生成与导出'}}</h4>
                                </div>
                                <p v-if="aiCardIndex == 1">科研最耗时的不仅是读，而是"找对该读什么"。酷学术会根据你当前阅读的主题、方法与关键词，推荐更相关的经典论文、综述与前沿工作，帮助你迅速补背景、找对比、定位创新点。
                                </p>
                                <p v-if="aiCardIndex == 2">让 AI 替您把厚书读薄。根据当前网页内容，AI可一键生成核心摘要。遇到复杂的原理或数据，你可以像聊天一样进行提问，极大的提升阅读效率。
                                </p>
                                <p v-if="aiCardIndex == 3">让 AI 替您把厚书读薄。根据当前网页内容，AI可一键生成核心摘要。遇到复杂的原理或数据，你可以像聊天一样进行提问，极大的提升阅读效率。</p>
                                <div class="demo-window-preview">
                                    <div class="demo-window small">
                                        <div class="window-header">
                                            <div class="window-dots">
                                                <span></span>
                                                <span></span>
                                                <span></span>
                                            </div>
                                        </div>
                                        <div class="window-content">
                                            <img v-if="aiCardIndex == 1" src="../assets/home/image10.png" alt="">
                                            <img v-if="aiCardIndex == 2" src="../assets/home/image11.png" alt="">
                                            <img v-if="aiCardIndex == 3" src="../assets/home/image12.png" alt="">
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <!-- Steps Section -->
            <section class="steps-section">
                <div class="section-container">
                    <h2 class="section-title">三步开启您的智能研究新体验</h2>

                    <div class="steps-card">
                        <div class="step-item">
                            <h3>1、添加至浏览器</h3>
                            <div class="step-icon">
                                <img src="../assets/home/icon1.svg" alt="">
                            </div>
                            <p>从应用商店一键安装</p>
                        </div>

                        <div class="step-divider"></div>

                        <div class="step-item">
                            <h3>2、 打开任意网页</h3>
                            <div class="step-icon">
                                <img src="../assets/home/icon2.svg" alt="">
                            </div>
                            <p>浏览海外文献或资讯</p>
                        </div>

                        <div class="step-divider"></div>

                        <div class="step-item">
                            <h3>3、尽情探索</h3>
                            <div class="step-icon">
                                <img src="../assets/home/icon3.svg" alt="">
                            </div>
                            <p>享受极速翻译与 AI 助手</p>
                        </div>
                    </div>
                </div>
            </section>

            <!-- Final CTA Section -->
            <section class="final-cta-section">
                <div class="cta-bg-decoration"></div>
                <div class="cta-card">
                    <h2>开启高效科研之旅</h2>
                    <p>加入 20000+科研人员，让学术研究更高效</p>

                    <button class="cta-button" @click="handleInstall(5)">
                        <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
                            <path d="M10 2.5V12.5M10 12.5L15 7.5M10 12.5L5 7.5" stroke="white" stroke-width="1.5"
                                stroke-linecap="round" stroke-linejoin="round" />
                            <path
                                d="M2.5 15V16.25C2.5 16.8023 2.94772 17.25 3.5 17.25H16.5C17.0523 17.25 17.5 16.8023 17.5 16.25V15"
                                stroke="white" stroke-width="1.5" stroke-linecap="round" />
                        </svg>
                        免费安装插件
                    </button>

                    <div class="browsers-list compact">
                        <div class="browser-item" @click="handleInstall(5)">
                            <div class="browser-icon small">
                                <img src="../assets/home/chrome.svg" alt="Chrome" />
                            </div>
                            <p>谷歌浏览器</p>
                        </div>
                        <div class="divider small"></div>
                        <div class="browser-item" @click="handleInstall(2)">
                            <div class="browser-icon small">
                                <img src="../assets/home/edge.svg" alt="Edge" />
                            </div>
                            <p>Edge 浏览器</p>
                        </div>
                        <div class="divider small"></div>
                        <div class="browser-item" @click="handleInstall(3)">
                            <div class="browser-icon small">
                                <img src="../assets/home/firefox.svg" alt="Firefox" />
                            </div>
                            <p>火狐浏览器</p>
                        </div>
                        <div class="divider small"></div>

                        <div class="browser-item" @click="handleInstall(4)">
                            <div class="browser-icon small">
                                <img src="../assets/home/360.svg" alt="360" />
                            </div>
                            <p>360浏览器</p>
                        </div>
                        <div class="divider small"></div>
                        <div class="browser-item" @click="handleInstall(5)">
                            <div class="browser-icon small">
                                <img src="../assets/home/zip.svg" alt="ZIP" />
                            </div>
                            <p>ZIP 安装包</p>
                        </div>
                    </div>
                </div>
            </section>

            <el-footer class="footer">
                <div class="wrapper">
                    <div class="footer_left">
                        <img src="../assets/logo.png" alt="" style="cursor: pointer">
                        <span>dic.cool</span>
                    </div>
                    <div class="footer_right">
                        <div class="about">
                            <p @click="toarey" class="toarey">隐私政策</p>
                            <p @click="aboutUs" class="toarey">关于我们</p>
                        </div>
                        <div class="footer_right_bottom">
                            <span>© 2024北京盈科千信科技有限公司</span>
                            <span><a href="https://beian.miit.gov.cn/" target="_blank">京ICP备15054044号-2</a></span>
                        </div>
                    </div>
                </div>
            </el-footer>
        </div>
    </div>
</template>

<script>
import comHeader from '../components/comHeader.vue'
export default {
    name: 'indexView',
    components: {
        comHeader
    },
    data() {
        return {
            ismobile: false,
            urlList: {
                1: 'https://chromewebstore.google.com/detail/%E9%85%B7%E5%AD%A6%E6%9C%AF/angphjdghkpkjdbljdfabiphhkolenbn?hl=zh-CN&utm_source=ext_sidebar',
                2: 'https://microsoftedge.microsoft.com/addons/detail/%E9%85%B7%E5%AD%A6%E6%9C%AF/ddbbchndnifnljpahafeoodeliphgond',
                3: 'https://addons.mozilla.org/addon/%E9%85%B7%E5%AD%A6%E6%9C%AF/',
                4: 'https://ext.se.360.cn/#/extension-detail?id=ofabpngdifhcjfijekcmhlbkkplhijlj'
            },
            browserId: 1, // 浏览器id
            aiCardIndex: 1, // AI 卡片索引
        }
    },
    created() {
        // 通过ua判断浏览器是否是手机端
        var ua = navigator.userAgent;
        if (ua.indexOf('Mobile') != -1) {
            this.ismobile = true;
        }
        if (ua.match(/Edg\/([\d.]+)/)) {
            this.browserId = 2
        } else if (ua.match(/Firefox\/([\d.]+)/)) {
            this.browserId = 3
        } else if (ua.match(/Chrome\/([\d.]+)/)) {
            this.browserId = 1
        }
    },
    methods: {
        
        download() {
            let params = {
                method: 'get',
                url: 'https://www.newacademic.online/diccool/DIC-COOL-SERVICE-V3/eventTracking/downloadlogs'
            }
            let channel = this.getChannel()
            if (channel) {
                params.params = {
                    channel
                }
            }
            this.$http(params).then(res => {
                console.log(res)
                window.open('https://addons.dic.cool/download/diccool.zip')
                this.$router.push('/apk')
            }).catch(err => {
                console.log(err)
            })
        },
        getChannel() {
            let url = window.location.href
            let urlArr = url.split('?')
            if (urlArr.length > 1) {
                let channel = urlArr[1].split('=')[0]
                let value = urlArr[1].split('=')[1]
                if (channel === 'channel' && this.channelList.includes(value)) {
                    return value
                } else {
                    return ''
                }
            } else {
                return ''
            }
        },
        // 安装方式
        handleInstall(item) {
            if (item === 5) {
                this.download()
            } else {
                let channel = this.getChannel()
                if (channel) {
                    let obj = {
                        1: 'chrome',
                        2: 'edge',
                        3: 'firefox',
                        4: 'other'
                    }
                    this.$http({
                        method: 'get',
                        url: 'https://www.newacademic.online/diccool/DIC-COOL-SERVICE-V3/eventTracking/openOtherStore?channel=' + channel + '&type=' + obj[item]
                    })
                }

                window.open(this.urlList[item])
            }
        },
        toarey() {
            this.$router.push('/privacy')
        },
        aboutUs() {
            this.$router.push('/aboutUs')
        },
    }
}

</script>

<style scoped lang="scss">
.footer {
    background: #fff;

    .wrapper {
        margin: 0 auto;
        height: 80px;
        width: 1280px;
        display: flex;
        justify-content: space-between;
        align-content: center;
        border-top: var(--stroke-weight-1, 1px) solid var(--color-blue-8857, rgba(220, 222, 229, 0.57));

        .footer_left {
            display: flex;
            align-items: center;
            gap: 4px;

            img {
                width: 28px;
            }

            span {
                color: #344054;
                font-family: "HarmonyOS Sans SC";
                font-size: 22px;
                font-weight: 900;
            }
        }

        .footer_right {
            display: flex;
            align-items: center;

            .about {
                display: flex;
                align-items: center;
                gap: 24px;
                margin: 0 50px;
                color: #666;
                font-family: "PingFang SC";
                font-size: var(--font-size-14, 14px);
                font-weight: 400;
                text-decoration: underline;
                cursor: pointer;
            }

            .footer_right_bottom {
                display: flex;
                align-items: center;
                gap: 12px;
                color: #667085;
                font-family: "PingFang SC";
                font-size: 13.2px;
                font-weight: 400;

                a {
                    color: #667085;
                }
            }
        }
    }
}
.landing-page {
    width: 100%;
    min-height: 100vh;
    background: #fff;
    font-family: 'PingFang SC', -apple-system, BlinkMacSystemFont, sans-serif;
}

/* ========== Hero Section ========== */
.hero-section {
    position: relative;
    background: url('../assets/home/back1.png') no-repeat center center;
    background-size: auto 100%;
    padding: 100px 320px;
    overflow: hidden;

    &::before {
        content: '';
        position: absolute;
        top: -50%;
        right: -20%;
        width: 60%;
        height: 60%;
        background: radial-gradient(circle, rgba(106, 75, 255, 0.05) 0%, transparent 70%);
        border-radius: 50%;
        animation: float 20s ease-in-out infinite;
    }

    &::after {
        content: '';
        position: absolute;
        bottom: -30%;
        left: -10%;
        width: 40%;
        height: 40%;
        background: radial-gradient(circle, rgba(164, 17, 209, 0.04) 0%, transparent 70%);
        border-radius: 50%;
        animation: float 15s ease-in-out infinite reverse;
    }
}

@keyframes float {

    0%,
    100% {
        transform: translate(0, 0) scale(1);
    }

    50% {
        transform: translate(20px, -20px) scale(1.1);
    }
}

.hero-bg-overlay {
    position: absolute;
    top: 30px;
    left: 320px;
    right: 320px;
    height: 537px;
    opacity: 0.8;
    pointer-events: none;
}

.hero-container {
    max-width: 1280px;
    margin: 0 auto;
    position: relative;
}

.hero-content {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 24px;
}

.hero-title {
    text-align: center;
}

.hero-title h1 {
    font-size: 46px;
    font-weight: 600;
    line-height: normal;
    margin: 0;
    padding: 26px 0 28px;
}

.title-normal {
    color: #000;
}

.title-gradient {
    background: linear-gradient(90deg, #a411d1 0%, #3106ff 100%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
}

.hero-subtitle {
    font-size: 16px;
    color: #5c629a;
    line-height: 30.6px;
    margin: 0;
}

/* Stats */
.stats-container {
    display: flex;
    gap: 90px;
    justify-content: center;
    margin: 20px 0;
}

.stat-item {
    display: flex;
    flex-direction: column;
    gap: 12px;
    align-items: center;
    padding: 26px 0 28px;
    position: relative;

    &::after {
        content: '';
        position: absolute;
        bottom: 0;
        left: 50%;
        transform: translateX(-50%);
        width: 60%;
        height: 2px;
        background: linear-gradient(90deg, transparent, rgba(106, 75, 255, 0.3), transparent);
        opacity: 0;
        transition: opacity 0.3s ease;
    }

    // &:hover::after {
    //     opacity: 1;
    // }
}

.stat-value {
    font-size: 32px;
    font-weight: 600;
    color: rgba(8, 7, 59, 0.8);
    line-height: normal;
}

.stat-value .plus {
    color: rgba(0, 0, 0, 0.8);
    line-height: 36px;
}

.stat-label {
    font-size: 14px;
    font-weight: 600;
    color: rgba(8, 7, 59, 0.8);
    margin: 0;
    line-height: normal;
}

/* CTA Button */
.cta-button-container {
    margin: 20px 0;
    display: flex;
    flex-direction: column;
    gap: 10px;
    align-items: center;
    justify-content: center;
    color: #999999;
    font-size: 12px;

    a:hover {
        text-decoration: underline;
        color: #6a4bff;
    }
}

.cta-button {
    background: #6a4bff;
    color: rgba(255, 255, 255, 0.94);
    border: 1px solid transparent;
    border-radius: 68px;
    padding: 17px 37px;
    font-size: 20px;
    font-weight: 600;
    font-family: 'PingFang SC', sans-serif;
    display: flex;
    align-items: center;
    gap: 8px;
    cursor: pointer;
    box-shadow: 0px 1px 2px 0px rgba(16, 20, 40, 0.13);
    transition: all 0.3s;
    line-height: normal;
}

.cta-button:hover {
    background: #5539e6;
    transform: translateY(-2px);
    box-shadow: 0px 4px 8px 0px rgba(16, 20, 40, 0.2);
}

/* Feature Tags */
.features-tags {
    display: flex;
    gap: 16px;
    padding: 12px 0;
}

.feature-tag {
    background: #f6f5ff;
    border-radius: 100px;
    padding: 4px 8px;
    display: flex;
    align-items: center;
    gap: 8px;
    transition: all 0.3s ease;

    // &:hover {
    //     background: #eeeaff;
    //     transform: scale(1.05);
    // }
}

.tag-icon {
    background: white;
    width: 24px;
    height: 24px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 6px;
}

.feature-tag span {
    font-size: 14px;
    color: #3a3aa6;
    line-height: normal;
}

/* Browsers List */
.browsers-list {
    display: flex;
    gap: 16px;
    align-items: center;
}

.browser-item {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 8px;
    padding: 4px 8px;
    cursor: pointer;
    transition: transform 0.3s ease;

    // &:hover {
    //     transform: translateY(-2px);

    //     p {
    //         color: #6a4bff;
    //     }
    // }
}

.browser-icon {
    width: 26px;
    height: 26px;
    display: flex;
    align-items: center;
    justify-content: center;

    img {
        width: 100%;
        height: 100%;
        object-fit: contain;
    }
}

.browser-icon.small {
    width: 20px;
    height: 20px;
}

.browser-item p {
    font-size: 14px;
    color: #999;
    margin: 0;
    line-height: normal;
}

.divider {
    width: 1px;
    height: 48px;
    background: #e5e5e5;

    &.small {
        height: 24px;
    }
}

/* ========== Problems Section ========== */
.problems-section {
    background: #fff;
    padding: 80px 0;
}

.section-container {
    max-width: 1280px;
    margin: 0 auto;
}

.section-header {
    text-align: center;
    // margin-bottom: 60px;
    padding: 0 0 80px;
    display: flex;
    flex-direction: column;
    align-items: center;

    .title_back_text {
        position: relative;

        .title_back {
            position: absolute;
            top: -80px;
            left: 50%;
            transform: translateX(-50%);
            z-index: 0;
        }
    }


}



.section-header h2 {
    font-size: 36px;
    font-weight: 600;
    color: #101828;
    margin: 0 0 16px 0;
    line-height: normal;
    position: relative;
    display: inline-block;

    // &::after {
    //     content: '';
    //     position: absolute;
    //     bottom: -8px;
    //     left: 50%;
    //     transform: translateX(-50%);
    //     width: 60px;
    //     height: 3px;
    //     background: linear-gradient(90deg, #a411d1 0%, #6a4bff 100%);
    //     border-radius: 2px;
    // }
}

.section-header p {
    font-size: 20px;
    color: #666;
    margin: 0;
    line-height: 30.6px;
}

.problems-grid {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 24px;
}

.problem-card {
    min-width: 410px;
    height: 383px;
    border-radius: 10px;
    padding: 32px;
    display: flex;
    flex-direction: column;
    gap: 12px;
    position: relative;
    transition: transform 0.3s ease, box-shadow 0.3s ease;

    // &:hover {
    //     transform: translateY(-4px);
    //     box-shadow: 0 8px 24px rgba(0, 0, 0, 0.1);
    // }
}

.problem-content {
    position: relative;
    padding: 24px 0;
    display: flex;
    flex-direction: column;
    gap: 40px;
    z-index: 1;
}

.problem-1 {
    background: linear-gradient(96.27deg, rgba(255, 226, 161, 0.3) 0%, rgba(255, 166, 146, 0.3) 100%),
        linear-gradient(90deg, rgba(255, 255, 255, 0.1) 0%, rgba(255, 255, 255, 0.1) 100%);
}

.problem-2 {
    background: linear-gradient(94.8deg, rgba(255, 233, 206, 0.27) 0.37%, rgba(247, 151, 170, 0.3) 100%),
        linear-gradient(90deg, rgba(255, 255, 255, 0.1) 0%, rgba(255, 255, 255, 0.1) 100%);
}

.problem-3 {
    background: linear-gradient(94.8deg, rgba(241, 233, 254, 0.3) 0.37%, rgba(241, 181, 147, 0.3) 100%),
        linear-gradient(90deg, rgba(255, 255, 255, 0.1) 0%, rgba(255, 255, 255, 0.1) 100%);
}

.problem-icon {
    position: absolute;
    right: 0px;
    bottom: 20px;
    pointer-events: none;
    user-select: none;
    z-index: 1;

    img {
        width: 163px;
    }
}

.problem-card h3 {
    color: #FFB100;
    font-family: "PingFang SC";
    font-size: 22px;
    font-weight: 600;
    white-space: nowrap;
}

.problem-1 h3 {
    color: #ffb100;
}

.problem-2 h3 {
    color: #ff5a34;
}

.problem-3 h3 {
    color: #ff5900;
}

.problem-points {
    display: flex;
    flex-direction: column;
    gap: 16px;
}

.point-item {
    display: flex;
    align-items: center;
    gap: 4px;
    font-size: 16px;
    font-weight: 500;
    color: #333;
    line-height: normal;

    svg {
        flex-shrink: 0;
    }
}

.problem-desc {
    width: 200px;
    color: #666;
    font-family: "PingFang SC";
    font-size: 14px;
}

/* ========== Comparison Section ========== */
.comparison-section {
    background: linear-gradient(123.32deg, #f4f5fc 0%, #ffffff 100%);
    padding: 80px 0;
    overflow: hidden;
}

.section-title {
    font-size: 36px;
    font-weight: 600;
    color: #101828;
    text-align: center;
    line-height: normal;
    padding-bottom: 80px;
}

.comparison-wrapper {
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    max-width: 1280px;
    margin: 0 auto;

    img {
        width: 1280px;
    }
}

.comparison-badge {
    position: absolute;
    top: 100px;
    left: 50%;
    transform: translateX(-50%);
    background: linear-gradient(180deg, #f2dcff 0%, #d997ff 100%);
    border: 1px solid #e9c4ff;
    border-radius: 100px;
    padding: 10px 50px;
    font-size: 27.5px;
    font-weight: 600;
    color: white;
    box-shadow: 0px 11.392px 22.336px 0px rgba(130, 53, 185, 0.09);
    z-index: 10;
    line-height: 1.8;
    animation: pulse 2s ease-in-out infinite;
}

@keyframes pulse {

    0%,
    100% {
        box-shadow: 0px 11.392px 22.336px 0px rgba(130, 53, 185, 0.09);
    }

    50% {
        box-shadow: 0px 11.392px 32.336px 0px rgba(130, 53, 185, 0.18);
    }
}

.badge-decoration {
    position: absolute;
    top: 20px;
    left: 50%;
    transform: translateX(-50%);
    font-size: 100px;
    color: rgba(106, 75, 255, 0.1);
    z-index: 1;
}

.comparison-cards {
    display: flex;
    gap: 0;
    align-items: flex-end;
    padding-right: 82px;
}

.comparison-card {
    backdrop-filter: blur(2.5px);
    border: 1px solid white;
    border-radius: 12.5px;
    padding: 30px;
    min-width: 468px;
    box-shadow: 0px 0px 50px 0px rgba(47, 0, 107, 0.11);
    display: flex;
    flex-direction: column;
    gap: 30px;
    transition: all 0.3s ease;

    // &:hover {
    //     box-shadow: 0px 8px 60px 0px rgba(47, 0, 107, 0.15);
    // }
}

.left-card {
    background: rgba(255, 255, 255, 0.1);
    z-index: 1;
    margin-right: -82px;
    height: 596.5px;
}

.right-card {
    background: linear-gradient(180deg,
            rgba(155, 79, 253, 0.2) 0%,
            rgba(255, 255, 255, 1) 100%);
    z-index: 2;
    padding-top: 42.5px;
}

.comparison-card h3 {
    font-size: 27.5px;
    font-weight: 600;
    margin: 0;
    line-height: 1.8;
}

.left-card h3 {
    color: #666;
}

.right-card h3 {
    color: #000;
}

.features-list {
    display: flex;
    flex-direction: column;
    gap: 37.5px;
}

.feature-item {
    display: flex;
    align-items: center;
    gap: 15px;
    font-size: 25px;
    line-height: 1.8;
    transition: all 0.3s ease;
    position: relative;
    padding-left: 10px;

    &::before {
        content: '';
        position: absolute;
        left: 0;
        width: 4px;
        height: 0;
        background: linear-gradient(180deg, #6a4bff 0%, #a411d1 100%);
        border-radius: 2px;
        transition: height 0.3s ease;
    }
}

.feature-item.disabled {
    color: #989898;
}

.feature-item:not(.disabled) {
    color: #000;
}

/* ========== Features Section ========== */
.features-section {
    background: linear-gradient(101deg, #FFF 0.95%, #E6F4FF 100%);
    padding: 80px 0 80px;
    overflow: hidden;
}

.features-showcase {
    display: flex;
    flex-direction: column;
    gap: 120px;
}

.feature-row {
    display: flex;
    align-items: center;
}

.feature-visual {
    img {
        width: 680px;
        height: 445px;
    }
}

.feature-description {
    flex: 1;
    padding: 20px 40px;
    display: flex;
    flex-direction: column;
    gap: 50px;
}

.feature-description h3 {
    font-size: 30px;
    font-weight: 600;
    line-height: normal;
    margin: 0;
    color: #1d0838;
    letter-spacing: 0.9px;
}

.feature-description p {
    font-size: 20px;
    color: #322b3c;
    line-height: 1.5;
    margin: 0;
    letter-spacing: 0.6px;
}

.feature-highlights {
    display: flex;
    flex-direction: column;
    gap: 20px;
}

.highlight-item {
    padding-bottom: 18px;
    padding-left: 30px;
    position: relative;

    .purple-text {
        background: url('../assets/home/purpleBack.svg') no-repeat left bottom 3px;
        background-size: auto 15px;
    }

    .blue-text {
        background: url('../assets/home/blueBack.svg') no-repeat left bottom 3px;
        background-size: max-content 15px;
    }

    .img-left {
        width: 19px;
        height: 36px;
        position: absolute;
        left: 0;
        bottom: 23.5px;
    }

    .img-right {
        width: 19px;
        height: 36px;
        position: absolute;
        right: 0;
        bottom: 23.5px;
    }

    &.align-right {
        text-align: right;
        padding-right: 30px;

        .purple-text {
            background: url('../assets/home/purpleBack.svg') no-repeat right bottom 3px;
        }

        .blue-text {
            background: url('../assets/home/blueBack.svg') no-repeat right bottom 3px;
        }
    }
}

@keyframes shimmer {
    0% {
        left: -100%;
    }

    100% {
        left: 100%;
    }
}

.highlight-item h4 {
    font-size: 26px;
    font-weight: 600;
    color: #1d0838;
    margin: 0 0 8px 0;
    letter-spacing: 0.78px;
    line-height: 1.5;
}

.highlight-item p {
    font-size: 14px;
    color: #322b3c;
    margin: 0;
    letter-spacing: 0.42px;
    line-height: 1.5;
}

/* Feature Tags Row */
.feature-tags-row {
    display: flex;
    gap: 50px;
}

.feature-tag-item {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
    padding-bottom: 10px;
}

.tag-bar {
    width: 118px;
    height: 15px;
    border-radius: 2px;

}

.feature-tag-item span {
    display: inline-block;
    font-size: 26px;
    font-weight: 600;
    color: #0c2462;
    letter-spacing: 0.78px;
    line-height: 1.5;
    background: url('../assets/home/blueBack.svg') no-repeat left bottom 3px;
    background-size: 100% 15px;
}

/* ========== AI Section ========== */
.ai-section {
    background: url('../assets/home/back2.png') no-repeat center center;
    background-size: auto 100%;
    padding: 80px 0;
    position: relative;
    overflow: hidden;
}

.section-bg-decoration {
    position: absolute;
    top: 0;
    left: 50%;
    transform: translateX(-50%);
    width: 1440px;
    height: 900px;
    opacity: 1;
    pointer-events: none;
}

.ai-features-grid {
    display: flex;
    gap: 48px;
}

.ai-features-left {
    display: flex;
    flex-direction: column;
    gap: 32px;
    flex: 0 0 380px;
}

.ai-card {
    background: linear-gradient(-89.47deg, rgba(255, 231, 214, 0.05) 1.52%, rgba(255, 174, 95, 0.05) 98%),
        linear-gradient(90deg, rgba(255, 255, 255, 0.1) 0%, rgba(255, 255, 255, 0.1) 100%);
    backdrop-filter: blur(2px);
    border: 1px solid white;
    border-radius: 4px;
    padding: 10px 16px;
    box-shadow: 0px 4px 4px 0px rgba(254, 126, 97, 0.06);
    display: flex;
    flex-direction: column;
    gap: 8px;
    cursor: pointer;
    transition: all 0.3s ease;

    // &:hover {
    //     transform: translateX(4px);
    //     box-shadow: 0px 6px 12px 0px rgba(254, 126, 97, 0.12);
    // }

    &.active {
        background: linear-gradient(-89.47deg, rgba(255, 231, 214, 0.3) 1.52%, rgba(255, 174, 95, 0.3) 98%),
            linear-gradient(90deg, rgba(255, 255, 255, 0.1) 0%, rgba(255, 255, 255, 0.1) 100%);
        border-color: #ffe2c6;
        transform: translateX(8px);
    }
}

.ai-card h4 {
    font-size: 24px;
    font-weight: 700;
    margin: 0;
    line-height: 1.8;
}

.ai-card.active h4 {
    color: #ff5c00;
}

.ai-card:not(.active) h4 {
    color: #666;
}

.ai-points {
    display: flex;
    flex-direction: column;
    gap: 5px;
}

.ai-point {
    font-size: 14px;
    display: flex;
    align-items: center;
    gap: 5px;
    letter-spacing: 0.42px;
    line-height: 1.5;

    svg {
        flex-shrink: 0;
    }

    &.hash {
        .hash-symbol {
            color: #ff8d1f;
            font-weight: 900;
        }
    }
}

.ai-card.active .ai-point {
    color: #322b3c;
}

.ai-card:not(.active) .ai-point {
    color: #756962;
}

.ai-features-right {
    flex: 1;
}

.ai-demo-card {
    background: linear-gradient(180deg, rgba(255, 92, 0, 0.02) 0%, rgba(255, 92, 0, 0) 74.544%);
    border: 1px solid #ff5c00;
    border-radius: 16px;
    padding: 24px;
    backdrop-filter: blur(2.5px);
    display: flex;
    flex-direction: column;
    gap: 16px;
    transition: all 0.3s ease;

    // &:hover {
    //     box-shadow: 0 8px 24px rgba(255, 92, 0, 0.15);
    //     transform: translateY(-2px);
    // }
}

.demo-title-bar {
    display: flex;
    flex-direction: column;
    gap: 8px;
}

.window-content {
    img {
        width: 446px;
    }
}

.demo-title-bar h4 {
    font-size: 24px;
    font-weight: 700;
    color: #ff5c00;
    margin: 0;
    letter-spacing: 0.72px;
    line-height: 1.5;
}

.ai-demo-card p {
    font-size: 16px;
    color: #333;
    line-height: 1.5;
    margin: 0;
}


.literature-preview {
    width: 100%;
    height: 200px;
    background: #f9fafb;
    border-radius: 8px;
}

/* ========== Steps Section ========== */
.steps-section {
    background: radial-gradient(50% 50% at 50% 50%, rgba(209, 193, 255, 0.60) 0%, rgba(255, 255, 255, 0.60) 100%);
    padding: 80px 0;
    overflow: hidden;
}

.steps-card {
    background: rgba(255, 255, 255, 0.76);
    backdrop-filter: blur(10px);
    border: 1px solid white;
    border-radius: 24px;
    padding: 42.5px 30px 30px;
    display: flex;
    gap: 70px;
    align-items: center;
    justify-content: center;
    max-width: 1280px;
    margin: 0 auto;
}

.step-item {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 30px;
    width: 270px;
    transition: transform 0.3s ease;
}

.step-item h3 {
    font-size: 24px;
    font-weight: 600;
    color: #000;
    margin: 0;
    text-align: center;
    line-height: 1.8;
}

.step-icon {
    width: 60px;
    height: 60px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: linear-gradient(135deg, #f6f5ff 0%, #e9f1ff 100%);
    border-radius: 50%;
    box-shadow: 0 4px 12px rgba(106, 75, 255, 0.1);
    transition: all 0.3s ease;

    svg {
        width: 32px;
        height: 32px;
        color: #6a4bff;
    }
}

.step-item:hover .step-icon {
    transform: scale(1.1) rotate(5deg);
    box-shadow: 0 6px 16px rgba(106, 75, 255, 0.2);
}

.step-item p {
    font-size: 24px;
    color: #000;
    margin: 0;
    text-align: center;
    line-height: 1.8;
}

.step-divider {
    width: 1px;
    height: 156px;
    background: #e0e0e0;
}

/* ========== Final CTA Section ========== */
.final-cta-section {
    padding: 80px 0;
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
    overflow: hidden;
    background: url('../assets/home/back3.png') no-repeat center center;
    background-size: auto 100%;
}

.cta-bg-decoration {
    position: absolute;
    inset: 0;
    // background: radial-gradient(circle at center, rgba(209, 193, 255, 0.4) 0%, rgba(255, 255, 255, 1) 60%);
    pointer-events: none;
}

.cta-card {
    background: rgba(255, 255, 255, 0.76);
    backdrop-filter: blur(10px);
    border: 1px solid white;
    border-radius: 24px;
    padding: 25px;
    max-width: 746px;
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 20px;
    position: relative;
    z-index: 1;
    transition: all 0.3s ease;
}

.cta-card h2 {
    font-size: 25.9px;
    font-weight: 600;
    color: rgba(0, 0, 0, 0.9);
    margin: 0;
    line-height: 31.2px;
}

.cta-card>p {
    font-size: 16px;
    color: rgba(0, 0, 0, 0.6);
    margin: 0;
    text-align: center;
    line-height: 25.6px;
}

.browsers-list.compact {
    gap: 8px;
    flex-wrap: wrap;
    justify-content: center;

    .browser-item p {
        font-size: 12px;
    }
}

/* ========== Responsive Design ========== */
@media (max-width: 1400px) {
    .hero-section {
        padding: 80px 160px;
    }

    .section-title {
        padding: 0 160px 80px;
    }
}

@media (max-width: 1200px) {
    .problems-grid {
        grid-template-columns: 1fr;
        gap: 20px;
    }

    .feature-row {
        flex-direction: column !important;
    }

    .comparison-cards {
        flex-direction: column;
        align-items: center;
        padding: 0;
    }

    .left-card,
    .right-card {
        margin: 0;
        width: 100%;
        max-width: 468px;
    }

    .ai-features-grid {
        flex-direction: column;
    }

    .ai-features-left {
        flex: 1;
    }
}

@media (max-width: 768px) {
    .hero-section {
        padding: 60px 20px;
    }

    .hero-title h1 {
        font-size: 32px;
    }

    .stats-container {
        flex-direction: column;
        gap: 40px;
    }

    .browsers-list {
        flex-direction: column;
    }

    .steps-card {
        flex-direction: column;
        gap: 40px;
    }

    .step-divider {
        width: 48px;
        height: 1px;
        transform: rotate(90deg);
    }

    .section-title {
        padding: 0 20px 60px;
        font-size: 28px;
    }

    .feature-description {
        padding: 20px;
    }

    .feature-description h3 {
        font-size: 24px;
    }

    .feature-description p {
        font-size: 16px;
    }
}
</style>
